'use client';

import React from 'react';
import Header from '@/components/Header';
import Footer from '@/components/Footer';
import Breadcrumbs from '@/components/Breadcrumbs';
import HFElement1 from '@/components/HFElement1';
import FAQSection from '@/components/FAQSection';
import { harleyFilterFaqs } from '@/data/faqData';

const HarleyFilterPage = () => {
  return (
    <>
      <Header />
      <div className="header-gap-creator"></div>
      <main>
        <Breadcrumbs items={[{ label: 'Harley Filters' }]} />
        <div className="container-0">
          <HFElement1 />
          <FAQSection faqs={harleyFilterFaqs} title="FAQs About Harley Air Filters" boldAnswer />
        </div>
      </main>
      <Footer />
    </>
  );
};

export default HarleyFilterPage;
